import styled from 'styled-components';

import React from 'react';
import palette from '../../../lib/styles/palette';
import { library_pipe_conveyor } from './library-pipe-conveyor';

const SelectPipeDia = ({
    setPipeDiameter,
    setBeltWidth,
    setIsOpenModal,
    // initializeOutput,
    requiredSectionArea,
}) => {
    const onSelection = (item) => {
        if (Number(requiredSectionArea) >= Number(item.area100)) {
            alert('선택한 Pipe Diameter의 운반 가능한 면적이 실제 필요한 단면적보다 작습니다. 다시 선택하세요.');
            return;
        }

        // if (Number(item.beltWidth) > 2200) {
        //     alert('현재는 상세정보가 없습니다. 추후 업데이트 예정. 25년 2월 현재');
        //     return;
        // }

        setPipeDiameter(item.pipeDiameter)
        setBeltWidth(item.beltWidth)
        
        setIsOpenModal(false);
        // initializeOutput();
    };

    const onCancel = () => {
        setIsOpenModal(false);
    };

    return (
        <FullScreen>
            <WhiteBox>
                <div style={{ marginTop: '2rem' }}>
                    <p>Required Sectional Area : {requiredSectionArea} m2</p>
                    <div>
                        <Table className="text-center">
                            <thead>
                                <tr>
                                    {/* <th></th> */}
                                    <th>Pipe Dia.<br/>(mm)</th>
                                    <th>Belt Width<br/>(mm)</th>
                                    <th>100% Area<br/>(mm2)</th>
                                    <th>75% Area<br/>(mm2)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {library_pipe_conveyor.map(item => 
                                    <tr key={item.id} className='clickable' /*className={Number(item.beltWidth) <= 2200 ? 'clickable' : 'non-clickable'}*/ onClick={() => onSelection(item)}>
                                        {/* <td></td> */}
                                        <td className="center-align">{item.pipeDiameter}</td>
                                        <td className="right-align">{item.beltWidth}</td>
                                        <td className="left-align gap-6">{item.area100}</td>
                                        <td className="left-align gap-6">{item.area75}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                {/* Button */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }} className="mt-12 flex justify-end gap-2">
                    <Button
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                </div>
            </WhiteBox>
        </FullScreen>
    );
}

export default SelectPipeDia;

const Button = styled.button`
    background: ${palette.gray[3]};
    color: ${palette.gray[8]};
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    &:hover {
        background-color: ${palette.gray[4]};
        cursor: pointer;
    }

`;

const FullScreen = styled.div`
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const WhiteBox = styled.div`
    // width: 320px;
    background: white;
    padding: 1.5rem;
    border-radius: 4px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.125);
    h2 {
        margin-top: 0;
        margin-bottom: 1rem;
    }
    p {
        margin-bottom: 3rem;
    }
    .buttons {
        display: flex;
        justify-content: flex-end;
        margin-top: 1rem;
    }
`;

const Table = styled.table`
    border-collapse: collapse;
    th {
        padding-left: 1rem;
        padding-bottom: 1rem;
        
    }
    td {
        padding: 0.25rem;
    }
    // tr {
    //     &:hover {
    //         cursor: pointer;
    //         background-color: ${palette.gray[2]};
    //     }
    // }
    .clickable {
        &:hover {
            cursor: pointer;
            background-color: ${palette.gray[2]};
        }
    }
    .non-clickable {
        color: ${palette.gray[6]};
        &:hover {
            cursor: not-allowed
        }
    }
    .center-align {
        text-align: center;
    }
    .left-align.gap-6 {
        text-align: left;
        padding-left: 1.5rem;
    }
    .right-align {
        text-align: right;
        padding-right: 1.5rem;
    }
`;

// const StyledInput = ({ label, unit, value, onChange, spacing = 16, ...props }) => {
//     return (
//         <label className="flex flex-col gap-1 text-gray-700 font-medium">
//             <span className="text-sm">{label}</span>
//             <div className="relative w-full">
//                 <input
//                     className={`w-full px-4 py-2 text-right border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none transition duration-300 ${
//                         spacing ? `pr-${spacing}` : 'pr-16'
//                     }`}
//                     {...props}
//                     value={value}
//                     onChange={onChange}
//                 />
//                 {unit && (
//                     <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm">{unit}</span>
//                 )}
//             </div>
//         </label>
//     );
// };
